import { Controller } from '@hotwired/stimulus';
import { paint } from '../lib/dom';

export default class extends Controller {
  static targets = ['panel', 'segment'];

  static classes = ['segmentActive', 'segmentIdle'];

  select({ params: { provider } }) {
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.provider !== provider;
    });

    this.segmentTargets.forEach((segment) => {
      this.#paint(segment, segment.dataset.provider === provider);
    });
  }

  #paint(segment, active) {
    segment.setAttribute('aria-pressed', String(active));
    paint(segment, active, this.segmentActiveClasses, this.segmentIdleClasses);
  }
}
